import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Admin/Buscando';
import Cabecalho from 'Component/Admin/Cabecalho';
import SemRegistros from 'Component/Admin/SemRegistros';
import { UsuarioLista } from 'Component/Admin/Usuario';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Form, { Campo, Selecao } from 'Component/Form';
import Paginacao from 'Component/Paginacao';
import { useRecuperarUsuariosQuery } from 'Service';
import { MASCARA_CPF, PERMISSOES, SIM_OU_NAO } from 'View/constants';

const Default = (): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, refetch, isFetching, isLoading } = useRecuperarUsuariosQuery({
    contain: ['Assinaturas'],
    page: searchParams.get('pagina') || 1,
    options: {
      busca: { termo: searchParams.get('busca') || '' },
      cpf: searchParams.get('cpf') || '',
      assinatura: searchParams.get('assinatura'),
      permissao: searchParams.get('permissao') || '',
    },
    sort: 'Usuarios.criado',
    direction: 'desc',
  });

  const filtrar = (
    dados: { [chave: string]: string },
    form: FormikHelpers<FormikValues>
  ) => {
    for (const filtro in dados) {
      if (dados[filtro] !== '') {
        searchParams.set(filtro, dados[filtro]);
      } else {
        searchParams.delete(filtro);
      }
    }

    searchParams.set('pagina', '1');
    setSearchParams(searchParams);

    form.setSubmitting(false);
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <Cabecalho
        titulo="Usuários"
        descricao="Listagem de usuários cadastrados no banco de dados"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        desabilitado={isFetching}
        inicial={{
          busca: searchParams.get('busca') || '',
          cpf: searchParams.get('cpf') || '',
          assinatura: searchParams.get('assinatura') || '',
          permissao: searchParams.get('permissao') || '',
        }}
      >
        <div className="row">
          <div className="col-md-3 mb-3">
            <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
            <BotaoLink
              tema="success"
              icone="plus-lg"
              to="/admin/usuarios/adicionar"
            >
              Adicionar
            </BotaoLink>
          </div>
          <div className="col-md-9 mb-3">
            <div className="hstack gap-3">
              <Selecao
                name="permissao"
                opcoes={PERMISSOES}
                padrao="Permissão"
              />
              <Selecao
                name="assinatura"
                opcoes={SIM_OU_NAO}
                padrao="Tem assinatura"
              />
              <Campo name="cpf" rotulo="CPF" mascara={MASCARA_CPF} />
              <Campo name="busca" rotulo="Digite o que deseja buscar" />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={data?.usuarios.length}
        redirecionar="/admin/usuarios/adicionar"
      />
      <div className="bg-white shadow-sm rounded">
        {data?.usuarios?.map((usuario) => (
          <UsuarioLista
            key={`${usuario.id}-${usuario.modificado}`}
            dados={usuario}
          />
        ))}
      </div>
      <Paginacao dados={data?.paginacao} desabilitado={isFetching} />
    </div>
  );
};

export default Default;
